import styled from '@emotion/styled'

export const StyleWhoWeAreWrapper = styled.div`
  display: flex;
  padding: 16px 60px;
  align-items: stretch;
  justify-content: center;
  flex-direction: row;
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 16px 8px;
  }
`

export const StyleRightContentWrapper = styled.div`
  flex: 1.5;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`
